import { RouterProvider } from 'react-router-dom';
import { AppRoutes } from './routes/routes';
import { LocaleProvider } from './context/locale/provider';

export function App() {
  const environment = import.meta.env.MODE;

  return (
    <LocaleProvider environment={environment as 'sandbox' | 'development' | 'qa' | 'production'}>
      <RouterProvider router={AppRoutes()} />
    </LocaleProvider>
  );
}
